// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_si-5";
export var filledCircle = "_si-4";
export var historyEntry = "_si-3";
export var messageSideLeft = "_si-1";
export var messageSideRight = "_si-2";
export var orderTrackingCarouselWrapper = "_si-6";
export var orderTrackingInfoContainer = "_si-0";